import React, { useEffect, useState, useContext } from "react";
import styled from "styled-components";
import { useIntl } from "gatsby-plugin-intl";
import { withStoreContext } from "gatsby-plugin-shopify-buy";
import { changeLocale, IntlContextConsumer } from "gatsby-plugin-intl";

import { GlobalDispatchContext, GlobalStateContext } from "../../context";
import IntlData from "./intlData";
import KCRowDropdown from "Components/common/kcRowDropdown";
import CloseIcon from "Components/common/closeIcon";
import Divider from "Components/common/divider";
import FlagIcon from "Components/common/flagIcon";
import KCButton from "Components/KCButton";

const StyledWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  z-index: 999;
  font-family: ${(props) => props.theme.font.sans};
  pointer-events: ${(props) => (props.isShown ? "auto" : "none")};
  display: flex;
  justify-content: flex-end;
  overflow: scroll;
`;

const StyledOverlay = styled.div`
  background-color: ${(props) => props.theme.color.darkGrey};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  z-index: -1;
  opacity: ${(props) => (props.isShown ? "0.6" : "0")};
  pointer-events: ${(props) => (props.isShown ? "auto" : "none")};
  transition: opacity 0.2s ${(props) => (props.isShown ? "0s" : "0.2s")};
`;

const StyledMenu = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.color.white};
  width: 100%;
  opacity: ${(props) => (props.isShown ? "1" : "0")};
  pointer-events: ${(props) => (props.isShown ? "auto" : "none")};
  transition: opacity 0.2s ${(props) => (props.isShown ? "0.2s" : "0s")};
  ${(props) => props.theme.responsive.mobile} {
    width: 30rem;
  }
`;

const StyledHeader = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: space-between;
`;

const StyledSubtitle = styled.div`
  font-size: 0.7rem;
  width: 60%;
  color: ${(props) => props.theme.color.dimmerGrey};
  line-height: 0.9rem;
  margin-top: 0.4rem;
  margin-bottom: 1rem;
`;

const StyledBold = styled.span``;

const FlagIconWrapper = styled.span`
  vertical-align: top;
  margin-left: 2px;
`;

const StyledTitle = styled.div`
  font-size: 2.6rem;
  font-weight: 600;
`;

const StyledSection = styled.div`
  padding: 1rem 1rem 2rem 1rem;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.color.white};
`;

const StyledSectionTitle = styled.div`
  font-weight: 600;
`;

const StyledSectionMenu = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.8rem;
`;

const StyledLanguageButton = styled.div`
  width: 6rem;
  height: 2rem;
  background-color: ${(props) =>
    props.isSelected ? props.theme.color.dimGrey : props.theme.color.smoke};
  color: ${(props) =>
    props.isSelected ? props.theme.color.smoke : props.theme.color.dimGrey};
  margin-right: 0.4rem;
  margin-bottom: 0.4rem;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.2rem;
  transition: all 0.2s;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const StyledCountryButton = styled.div`
  width: 6.4rem;
  height: 2.3rem;
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.isSelected ? props.theme.color.dimGrey : "transparent"};
  color: ${(props) =>
    props.isSelected ? props.theme.color.smoke : props.theme.color.dimGrey};
  margin-right: 0.3rem;
  margin-bottom: 0.3rem;
  padding: 0.1rem 0.3rem;
  transition: all 0.2s;
  border-radius: 2px;

  &:hover {
    cursor: pointer;
    background-color: ${(props) =>
      props.isSelected ? props.theme.color.darkGrey : props.theme.color.smoke};
  }
`;

const StyledCountryButtonContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
    flex: 1;
    margin-left: 0.4rem;s
`;

const StyledCountryButtonTitle = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 0.7rem;
`;

const StyledCountryButtonSubtitle = styled.div`
  font-size: 0.6rem;
`;

const StyledCTAPadding = styled.div`
  flex-shrink: 0;
  height: 6rem;
  width: 100%;
  background-color: white;
`;

const StyledCTAWrapper = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: ${(props) => props.theme.color.black};
  border-radius: 3px 3px 0 0;
  ${(props) => props.theme.responsive.mobile} {
    width: 30rem;
  }
`;

const CONTINENTS = [
  "Europe",
  "Asia",
  "Oceania",
  "North America",
  "South America",
  "Africa",
];

const IntlPopup = ({ storeContext }) => {
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const intl = useIntl();

  const getLangName = (lang) => {
    switch (lang) {
      case "en":
        return "English";
      case "it":
        return "Italiano";
      case "es":
        return "Español";
      default:
        return "Eng";
    }
  };
  const handleLanguageChange = (language) => {
    changeLocale(language);
  };

  const isShown = state.isIntlPopupShown;
  const { currency, currencyCountry } = state;
  const [openRegion, setOpenRegion] = useState(
    Object.keys(IntlData).find((continent) =>
      IntlData[continent].find((country) => country.name === currencyCountry)
    )
  );
  return (
    <IntlContextConsumer>
      {({ languages, language: currentLocale }) => (
        <StyledWrapper isShown={isShown}>
          <StyledOverlay
            isShown={isShown}
            onClick={() =>
              dispatch({
                type: "SET_IS_INTL_POPUP_SHOWN",
                isShown: false,
              })
            }
          />
          <StyledMenu isShown={isShown}>
            <StyledHeader>
              <div>
                <StyledTitle>Locale</StyledTitle>
                <StyledSubtitle>
                  {intl.formatMessage({
                    id: `intlPopup.blurb.1`,
                  })}{" "}
                  <StyledBold>{getLangName(currentLocale)}</StyledBold>{" "}
                  {intl.formatMessage({
                    id: `intlPopup.blurb.2`,
                  })}{" "}
                  <StyledBold>
                    {currencyCountry} ({currency})
                  </StyledBold>
                  <FlagIconWrapper>
                    <FlagIcon name={currencyCountry} />
                  </FlagIconWrapper>
                </StyledSubtitle>
              </div>
              <CloseIcon
                size={0.6}
                handlerClick={() =>
                  dispatch({
                    type: "SET_IS_INTL_POPUP_SHOWN",
                    isShown: false,
                  })
                }
              />
            </StyledHeader>

            <StyledSection>
              <StyledSectionTitle>
                {intl.formatMessage({
                  id: `intlPopup.language`,
                })}
              </StyledSectionTitle>
              <StyledSectionMenu>
                {languages.map((language, i) => (
                  <StyledLanguageButton
                    isSelected={currentLocale === language}
                    key={`langOption=${i}`}
                    onClick={() => handleLanguageChange(language)}
                  >
                    {getLangName(language)}
                  </StyledLanguageButton>
                ))}
              </StyledSectionMenu>
            </StyledSection>

            <StyledSection>
              <StyledSectionTitle>
                {intl.formatMessage({
                  id: `intlPopup.region`,
                })}
              </StyledSectionTitle>
              <StyledSectionMenu>
                <Divider />
                {CONTINENTS.map((continent) => {
                  return (
                    <KCRowDropdown
                      key={continent}
                      title={continent}
                      isOpen={
                        openRegion === continent.toLowerCase().replace(" ", "-")
                      }
                      handlerOpen={() => {
                        let continentKey = continent
                          .toLowerCase()
                          .replace(" ", "-");
                        setOpenRegion(
                          openRegion === continentKey ? undefined : continentKey
                        );
                      }}
                    >
                      {IntlData[continent.toLowerCase().replace(" ", "-")].map(
                        (country) => (
                          <StyledCountryButton
                            isSelected={country.name === currencyCountry}
                            onClick={() =>
                              dispatch({
                                type: "SET_CURRENCY",
                                currency: country.currency,
                                country: country.name,
                              })
                            }
                            key={country.name}
                          >
                            <FlagIcon name={country.name} />
                            <StyledCountryButtonContent>
                              <StyledCountryButtonTitle>
                                {country.name}
                              </StyledCountryButtonTitle>
                              <StyledCountryButtonSubtitle>
                                {country.currency}
                              </StyledCountryButtonSubtitle>
                            </StyledCountryButtonContent>
                          </StyledCountryButton>
                        )
                      )}
                    </KCRowDropdown>
                  );
                })}
              </StyledSectionMenu>
            </StyledSection>
            <StyledCTAPadding />
            <StyledCTAWrapper>
              <KCButton
                handleClick={() => {
                  dispatch({
                    type: "SET_IS_INTL_POPUP_SHOWN",
                    isShown: false,
                  });
                }}
                label={intl.formatMessage({
                  id: `intlPopup.confirm`,
                })}
                buttonType="primary"
                isFullWidth={true}
                size="large"
              />
            </StyledCTAWrapper>
          </StyledMenu>
        </StyledWrapper>
      )}
    </IntlContextConsumer>
  );
};

export default withStoreContext(IntlPopup);
